import { Icon } from '../../icons';
// TODO: NoticeType?
export type MessageType = 'error' | 'info' | 'loading' | 'success' | 'warning';

type MessageIconProperties = {
  type: MessageType;
};

export const MessageIcon = ({ type }: MessageIconProperties) => {
  switch (type) {
    case 'error':
      return <Icon color="error" icon="close-circle-fill" />;
    case 'info':
      return <Icon color="info" icon="information-fill" />;
    case 'loading':
      return <Icon color="info" icon="loading-line" spin />;
    case 'success':
      return <Icon color="success" icon="check-circle-fill" />;
    case 'warning':
      return <Icon color="warning" icon="warning-fill" />;
  }
};
